import { FunctionComponent } from 'react';
import FursysFooterWrapper from './fursysFooter.style';
import { getStaticImageUrl } from '@utils/createImageUrl';
import PlusIcon from '../../public/icon/Plus';
import Link from 'next/link';
import { sendAmplitudeEvent } from '../../utils/amplitude';

const FursysFooter: FunctionComponent = () => {
  return (
    <FursysFooterWrapper>
      <div className="footerContent">
        <div className="topContent">
          <div className="question">
            <div className="question--title">
              제품이나 컨설팅에 대해
              <br />
              궁금하시다면 문의 부탁드립니다.
            </div>
            <div className="question--info">
              <div className="info-data number">
                <span className="info-data--infoMark"> T </span>
                <span className="info-data--infoContent"> 070-5038-1560 </span>
              </div>
              <div className="info-data email">
                <span className="info-data--infoMark"> E </span>
                <span className="info-data--infoContent">lawyers@lawcompany.co.kr</span>
              </div>
            </div>
          </div>
          <div className="notice">
            <span className="notice--title">유의사항</span>
            <p className="notice--content">인테리어 컨설팅은 무료 서비스입니다.</p>
            <p className="notice--content">담당자가 업무시간 내로 연락을 드립니다.</p>
            <p className="notice--content">1회 결제금액이 총 20만원을 넘어야 특별가격이 적용됩니다.</p>
            <p className="notice--content">제품 교환 및 환불은 FURSYS 담당자에게 문의 부탁드립니다.</p>
          </div>
        </div>
        <div className="ifLawyer">
          <div className="ifLawyer--text">
            <p className="title">
              혹시, 변호사님이신가요?
              <br className="mobile" />
              <span className="sub">로톡과 함께하면 좋은 점을 살펴보세요.</span>
            </p>
          </div>
          <div className="ifLawyer-landing">
            <Link href="/">
              <a
                className="link"
                target="_blank"
                onClick={() => sendAmplitudeEvent('sqr_click_fursys', { label: 'more-see' })}
              >
                알아보기
              </a>
            </Link>
            <div className="imgWrapper">
              <Link href="/">
                <a target="_blank" onClick={() => sendAmplitudeEvent('sqr_click_fursys', { label: 'thumbnail' })}>
                  <img className="lawyer-icon" src={getStaticImageUrl({ fileName: 'lawyer-icon.png' })} />
                  <div className="plusIcon">
                    <div className="plus">
                      <PlusIcon />
                    </div>
                  </div>
                </a>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </FursysFooterWrapper>
  );
};

export default FursysFooter;
